import { render, staticRenderFns } from "./DeclarationAttachments.vue?vue&type=template&id=55ee2f84"
import script from "./DeclarationAttachments.vue?vue&type=script&lang=js"
export * from "./DeclarationAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports